<template>
    <div class="relative" v-click-outside="onClickOutside">
        <slot v-bind:hide="hide" v-bind:show="show" v-bind:toggle="toggle"></slot>
        <div :class="[container, position]" v-if="isDisplayed && ! usesRightPanelModal">
            <slot name="submenu"></slot>
        </div>
        <div :class="[$spa.css.submenu.overlay.base, $spa.css.submenu.overlay.opacity]" v-if="overlay && isDisplayed" @click.stop.prevent="hide()"></div>
    
        <portal :to="rightPanelPortal" v-if="usesRightPanelModal">
            <right-panel-modal :name="modalName" @closed="hide">
                <slot name="submenu"></slot>
            </right-panel-modal>
        </portal>
    </div>
</template>

<script>
    import RightPanelModal from './RightPanelModal.vue';

    export default {
        components: {
            'right-panel-modal': RightPanelModal
        },
        computed: {
            usesRightPanelModal() {
                return this.useRightPanelOnSmallScreens && this.$screen.isBreakpointOrLess(this.modalBreakpoint);
            }
        },
        props: {
            useRightPanelOnSmallScreens: {
                type: Boolean,
                default: false
            },
            overlay: {
                type: Boolean,
                default: true
            },
            container: {
                type: String,
                default() {
                    return this.$spa.css.submenu.container.default
                }
            },
            position: {
                type: String,
                default: 'left-0'
            },
            modalBreakpoint: {
                type: String,
                default: 'md'
            },
            modalName: {
                type: String,
                default() {
                    return this.randomId();
                }
            },
            rightPanelPortal: {
                type: String,
                default: 'submenus'
            }
        },
        data() {
            return {
                isDisplayed: false
            }
        },
        methods: {
            onClickOutside()
            {
                if ( ! this.usesRightPanelModal ) {
                    this.hide();
                }
            },

            show()
            {
                if ( this.isDisplayed ) {
                    return;
                }

                this.isDisplayed = true;

                if ( this.usesRightPanelModal ) {
                    this.$modal.show(this.modalName);
                }

                this.$emit('shown');
            },

            hide()
            {
                if ( ! this.isDisplayed ) {
                    return;
                }

                this.isDisplayed = false;
                
                if ( this.usesRightPanelModal ) {
                    this.$modal.hide(this.modalName);
                }

                this.$emit('hidden');
            },

            toggle()
            {
                if ( this.usesRightPanelModal ) {
                    this.isDisplayed ? this.$modal.hide(this.modalName) : this.$modal.show(this.modalName);
                }

                this.isDisplayed = ! this.isDisplayed;

                this.isDisplayed ? this.$emit('shown') : this.$emit('hidden');
            }
        }
    }
</script>